import { Link } from "react-router-dom";
import { Facebook, Instagram, Youtube, Mail, Phone, MapPin } from "lucide-react";
import SocialIcons from "@/components/SocialIcons";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-[#0a0a0a] border-t border-white/5 mt-32">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <div className="mb-6"><Logo size="md" /></div>
          <p className="text-sm text-white/60 leading-relaxed">
            Noleggio e vendita di auto premium. Scegli il modello, durata e chilometraggio: al resto pensiamo noi.
          </p>
        </div>

        <div>
          <h4 className="heading-uc text-sm mb-4 text-white/90">Servizi</h4>
          <ul className="space-y-3 text-sm text-white/60">
            <li><Link to="/noleggio/breve" className="hover:text-[#22ff66]">Noleggio Breve Termine</Link></li>
            <li><Link to="/noleggio/lungo-termine" className="hover:text-[#22ff66]">Noleggio Lungo Termine</Link></li>
            <li><Link to="/noleggio/rent-to-buy" className="hover:text-[#22ff66]">Rent to Buy</Link></li>
            <li><Link to="/catalogo?listing_type=sale" className="hover:text-[#22ff66]">Vendita Auto Nuove</Link></li>
            <li><Link to="/catalogo?listing_type=sale" className="hover:text-[#22ff66]">Vendita Auto Usate</Link></li>
            <li><Link to="/abbonamenti" className="hover:text-[#22ff66]">Abbonamenti Annuali</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="heading-uc text-sm mb-4 text-white/90">Contatti</h4>
          <ul className="space-y-3 text-sm text-white/60">
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 mt-0.5 text-[#22ff66] shrink-0" />
              <span>Via Pontina 325<br />00128 Roma — Zona Eur Mostacciano</span>
            </li>
            <li className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-[#22ff66]" />
              <a href="tel:+393514269681" className="hover:text-white">+39 351 426 9681</a>
            </li>
            <li className="flex items-center gap-2">
              <Mail className="w-4 h-4 text-[#22ff66]" />
              <a href="mailto:info@utile-rent.com" className="hover:text-white">info@utile-rent.com</a>
            </li>
            <li>
              <a
                href="https://wa.me/393514269681"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-[#25D366] hover:underline"
              >
                <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" /></svg>
                Scrivici su WhatsApp
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="heading-uc text-sm mb-4 text-white/90">Seguici</h4>
          <SocialIcons variant="square" size="md" />
          <p className="text-xs text-white/40 mt-6 leading-relaxed">
            NO CARTA DI CREDITO • NO SCORING • NO BANCHE
          </p>
          <div className="mt-6 aspect-[4/3] bg-[#050505] border border-white/10 overflow-hidden">
            <iframe
              title="Mappa +UTILE"
              src="https://maps.google.com/maps?q=Via%20Pontina%20325%20Roma&t=&z=14&ie=UTF8&iwloc=&output=embed"
              className="w-full h-full grayscale opacity-90"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center text-xs text-white/40">
        © {new Date().getFullYear()} +UTILE. Tutti i diritti riservati. Via Pontina 325, Roma — Zona Eur Mostacciano
      </div>
    </footer>
  );
}
